import React  from 'react';
import { EditGuesser, InputGuesser } from "@api-platform/admin";
import { ReferenceInput, AutocompleteInput } from 'react-admin';

const GroupStepFormatPositionEdit = (props) => (
  <EditGuesser {...props}>
    <InputGuesser source="position" />
    <ReferenceInput
      label="Step format"
      source="stepFormats"
      reference="step_formats"
      perPage={1900}
    >
      <AutocompleteInput optionText="title" />
    </ReferenceInput>
  </EditGuesser>
  );

export default GroupStepFormatPositionEdit;